import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module';
import { sys } from './sys.module';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth, sys
    }
});